<template>
  <div class="correctness-header">
    <radio-button
      :correct="correct"
      :answered="true"
      :selected="true"
      size="large"
    ></radio-button>
    <span class="label">{{ label }}</span>
  </div>
</template>

<script>
import RadioButton from './RadioButton.vue';

export default {
  components: {
    RadioButton,
  },
  props: {
    correct: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    label() {
      return this.correct ? 'Correct' : 'Incorrect';
    },
  },
};
</script>

<style lang="scss" scoped>
.correctness-header {
  margin: 0 0 rem-calc(16) 0;
  padding: rem-calc(8) rem-calc(8) rem-calc(24);
  display: flex;
  align-items: center;
  gap: 0.5rem;

  span.label {
    font-size: rem-calc(30);
    font-weight: 600;
    line-height: rem-calc(32);
  }
}
</style>
